import { buttonVariants } from "components/ui/button";
import { ComboboxTrigger, ComboboxValue } from "components/ui/combobox";

export function SingleFilterTrigger({ labelFor, placeholder = "Select..." }) {
  return (
    <ComboboxTrigger
      className={buttonVariants({
        variant: "outline",
        className:
          "tw:w-52 tw:max-w-full tw:justify-between tw:bg-white tw:dark:bg-background",
      })}
    >
      <ComboboxValue>
        {selected =>
          selected ? (
            <span className="tw:min-w-0 tw:flex-1 tw:truncate tw:text-left">
              {labelFor(selected)}
            </span>
          ) : (
            <span className="tw:text-muted-foreground">{placeholder}</span>
          )
        }
      </ComboboxValue>
    </ComboboxTrigger>
  );
}
